// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BbGS","col":"styles_col__3JIRB"};